import { TBoundAction } from '../../actions/types/action';
import _ from 'lodash';
import { serializeRecruitmentProfile } from '../../../../../../shared/frontend/scripts/recruitment/utils';
import { LOCATION_CHANGE, LocationChangeAction } from '../../../../../../shared/frontend/libs/router/redux-store';

const initialState = {
  /* ownProfiles - all of the user's profiles */
  ownProfiles: {
    loading: false,
    loaded: false,
    error: false,
    profiles: []
  },
  featuredProfiles: {
    loading: false,
    loaded: false,
    error: false,
    profiles: []
  },
  recentlyPublishedProfiles: {
    loading: false,
    loaded: false,
    error: false,
    profiles: []
  },
  /* Application state - for all entity applications */
  application: {}

  /* */
};
type TValidatedProfile = {
  sourceProfile: any;
  targetProfile: any;
  checks: any[];
};
type NoParams = {};
type TSuccessfulProfileParams = { profiles: any[] };
type TProfileUpdateParams = { profiles: any[] };
type SuccessfulRequirementCheckProfilesParams = {
  [key: number]: {
    matchingProfiles: TValidatedProfile[];
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
};
export enum ActionTypes {
  /*
   * Featured Recruitment Profiles
   */
  LOAD_FEATURED_RECRUITMENT_PROFILES = 'SHARED/RECRUITMENT/LOAD_FEATURED_RECRUITMENT_PROFILES',
  LOAD_FEATURED_PROFILES_SUCCESS = 'SHARED/RECRUITMENT/LOAD_FEATURED_PROFILES_SUCCESS',
  LOAD_FEATURED_PROFILES_FAIL = 'SHARED/RECRUITMENT/LOAD_FEATURED_PROFILES_FAIL',
  /*
   * Recently Recruitment Profiles
   */
  LOAD_RECENTLY_PUBLISHED_RECRUITMENT_PROFILES = 'SHARED/RECRUITMENT/LOAD_RECENTLY_PUBLISHED_RECRUITMENT_PROFILES',
  LOAD_RECENTLY_PUBLISHED_PROFILES_SUCCESS = 'SHARED/RECRUITMENT/LOAD_RECENTLY_PUBLISHED_PROFILES_SUCCESS',
  LOAD_RECENTLY_PUBLISHED_PROFILES_FAIL = 'SHARED/RECRUITMENT/LOAD_RECENTLY_PUBLISHED_PROFILES_FAIL',
  /*
   * Own Profiles
   */
  LOAD_OWN_PROFILES = 'SHARED/RECRUITMENT/LOAD_OWN_PROFILES',
  LOAD_RECRUITMENT_PROFILES = 'SHARED/RECRUITMENT/LOAD_PROFILES',
  LOAD_PROFILES_SUCCESS = 'SHARED/RECRUITMENT/LOAD_PROFILE_SUCCESS',
  LOAD_PROFILES_FAIL = 'SHARED/RECRUITMENT/LOAD_PROFILE_FAIL',

  /*
   * Applications
   */
  REQUEST_PROFILES_FOR_APPLICATION = 'SHARED/RECRUITMENT/REQ_PROFILES_FOR_APPLICATION',
  LOAD_PROFILES_FOR_APPLICATION_SUCCESS = 'SHARED/RECRUITMENT/LOAD_PROFILES_FOR_APPLICATION_SUCCESS',
  LOAD_PROFILES_FOR_APPLICATION_FAIL = 'SHARED/RECRUITMENT/LOAD_PROFILES_FOR_APPLICATION_FAIL'
}

/*
 * Featured Recruitment Profiles Actions
 */
const loadFeaturedProfiles = () => ({
  type: ActionTypes.LOAD_FEATURED_RECRUITMENT_PROFILES,
  payload: {
    profiles: [],
    loaded: false,
    loading: true,
    error: false
  }
});

const loadFeaturedProfilesSuccess = (profiles: TSuccessfulProfileParams) => ({
  type: ActionTypes.LOAD_FEATURED_PROFILES_SUCCESS,
  payload: {
    profiles: _.map(profiles, (p) => serializeRecruitmentProfile({}, p)),
    loaded: true,
    loading: false,
    error: false
  }
});

const loadFeaturedProfilesFailure = () => ({
  type: ActionTypes.LOAD_FEATURED_PROFILES_FAIL,
  payload: {
    profiles: [],
    loading: false,
    loaded: true,
    error: true
  }
});

type TLoadFeaturedRecruitmentProfiles = TBoundAction<ActionTypes.LOAD_FEATURED_RECRUITMENT_PROFILES, NoParams>;
type TLoadFeaturedRecruitmentProfilesSuccess = TBoundAction<
  ActionTypes.LOAD_FEATURED_PROFILES_SUCCESS,
  TSuccessfulProfileParams
>;
type TLoadFeaturedRecruitmentProfilesFailure = TBoundAction<ActionTypes.LOAD_FEATURED_PROFILES_FAIL, NoParams>;
type TFeaturedRecruitmentProfileActions =
  | TLoadFeaturedRecruitmentProfiles
  | TLoadFeaturedRecruitmentProfilesSuccess
  | TLoadFeaturedRecruitmentProfilesFailure;

/*
 * Recently Recruitment Profiles Actions
 */
const loadRecentlyPublishedProfiles = () => ({
  type: ActionTypes.LOAD_RECENTLY_PUBLISHED_RECRUITMENT_PROFILES,
  payload: {
    profiles: [],
    loaded: false,
    loading: true,
    error: false
  }
});

const loadRecentlyPublishedProfilesSuccess = (profiles: TSuccessfulProfileParams) => ({
  type: ActionTypes.LOAD_RECENTLY_PUBLISHED_PROFILES_SUCCESS,
  payload: {
    profiles: _.map(profiles, (p) => serializeRecruitmentProfile({}, p)),
    loaded: true,
    loading: false,
    error: false
  }
});

const loadRecentlyPublishedProfilesFailure = () => ({
  type: ActionTypes.LOAD_RECENTLY_PUBLISHED_PROFILES_FAIL,
  payload: {
    profiles: [],
    loading: false,
    loaded: true,
    error: true
  }
});

type TLoadRecentlyRecruitmentProfiles = TBoundAction<
  ActionTypes.LOAD_RECENTLY_PUBLISHED_RECRUITMENT_PROFILES,
  NoParams
>;
type TLoadRecentlyRecruitmentProfilesSuccess = TBoundAction<
  ActionTypes.LOAD_RECENTLY_PUBLISHED_PROFILES_SUCCESS,
  TSuccessfulProfileParams
>;
type TLoadRecentlyRecruitmentProfilesFailure = TBoundAction<
  ActionTypes.LOAD_RECENTLY_PUBLISHED_PROFILES_FAIL,
  NoParams
>;
type TRecentlyRecruitmentProfileActions =
  | TLoadRecentlyRecruitmentProfiles
  | TLoadRecentlyRecruitmentProfilesSuccess
  | TLoadRecentlyRecruitmentProfilesFailure;

/*
 * Own Profiles Actions
 */
const loadOwnProfiles = () => ({
  type: ActionTypes.LOAD_RECRUITMENT_PROFILES,
  payload: {
    loaded: false,
    loading: true,
    error: false
  }
});

const loadProfilesSuccess = (profiles: TSuccessfulProfileParams) => ({
  type: ActionTypes.LOAD_PROFILES_SUCCESS,
  payload: {
    profiles: _.map(profiles, (p) => serializeRecruitmentProfile({}, p)),
    loaded: true,
    loading: false,
    error: false
  }
});

const updateOwnProfiles = (profiles: TProfileUpdateParams) => ({
  type: ActionTypes.LOAD_OWN_PROFILES,
  payload: {
    profiles,
    loaded: true,
    loading: false,
    error: false
  }
});

const loadProfilesFailure = () => ({
  type: ActionTypes.LOAD_PROFILES_FAIL,
  payload: { loading: false, loaded: true, error: true }
});

type TLoadOwnProfiles = TBoundAction<ActionTypes.LOAD_RECRUITMENT_PROFILES, NoParams>;
type TLoadProfilesSuccess = TBoundAction<ActionTypes.LOAD_PROFILES_SUCCESS, TSuccessfulProfileParams>;
type TUpdateOwnProfiles = TBoundAction<ActionTypes.LOAD_OWN_PROFILES, TSuccessfulProfileParams>;
type TLoadProfilesFailure = TBoundAction<ActionTypes.LOAD_PROFILES_FAIL, NoParams>;
type TOwnProfileActions = TLoadOwnProfiles | TLoadProfilesSuccess | TLoadProfilesFailure | TUpdateOwnProfiles;

/*
 * Application Profiles Actions
 */
const requestProfilesForApplication = (targetProfileId: number) => ({
  type: ActionTypes.REQUEST_PROFILES_FOR_APPLICATION,
  payload: {
    [targetProfileId]: {
      loading: true,
      loaded: false,
      error: false,
      matchingProfiles: []
    }
  }
});

const loadApplicationProfilesSuccess = (
  profiles: TValidatedProfile[],
  targetProfileId: string
): TLoadProfilesForAppSuccess => ({
  type: ActionTypes.LOAD_PROFILES_FOR_APPLICATION_SUCCESS,
  payload: {
    [targetProfileId]: {
      matchingProfiles: _.map(profiles, (p) => ({
        ...p,
        sourceProfile: serializeRecruitmentProfile({}, p.sourceProfile),
        targetProfile: serializeRecruitmentProfile({}, p.targetProfile)
      })),
      loaded: true,
      loading: false,
      error: false
    }
  }
});

const loadApplicationProfilesFail = () => ({
  type: ActionTypes.LOAD_PROFILES_FOR_APPLICATION_FAIL,
  payload: { loading: false, loaded: true, error: true }
});

type TRequestProfilesForApp = TBoundAction<ActionTypes.REQUEST_PROFILES_FOR_APPLICATION, NoParams>;
type TLoadProfilesForAppSuccess = TBoundAction<
  ActionTypes.LOAD_PROFILES_FOR_APPLICATION_SUCCESS,
  SuccessfulRequirementCheckProfilesParams
>;
type TLoadProfilesForAppFail = TBoundAction<ActionTypes.LOAD_PROFILES_FOR_APPLICATION_FAIL, NoParams>;
type TApplicationActions = TRequestProfilesForApp | TLoadProfilesForAppSuccess | TLoadProfilesForAppFail;

type TSupportedActions =
  | TFeaturedRecruitmentProfileActions
  | TRecentlyRecruitmentProfileActions
  | TOwnProfileActions
  | TApplicationActions
  | LocationChangeAction<{}>;

export default function recruitmentReducer(state = initialState, action: TSupportedActions) {
  switch (action.type) {
    case ActionTypes.LOAD_OWN_PROFILES:
    case ActionTypes.LOAD_RECRUITMENT_PROFILES:
    case ActionTypes.LOAD_PROFILES_SUCCESS:
    case ActionTypes.LOAD_PROFILES_FAIL: {
      const { ownProfiles } = state;
      return {
        ...state,
        ownProfiles: { ...ownProfiles, ...action.payload }
      };
    }

    case ActionTypes.LOAD_FEATURED_RECRUITMENT_PROFILES:
    case ActionTypes.LOAD_FEATURED_PROFILES_SUCCESS:
    case ActionTypes.LOAD_FEATURED_PROFILES_FAIL: {
      return {
        ...state,
        featuredProfiles: action.payload
      };
    }

    case ActionTypes.LOAD_RECENTLY_PUBLISHED_RECRUITMENT_PROFILES:
    case ActionTypes.LOAD_RECENTLY_PUBLISHED_PROFILES_SUCCESS:
    case ActionTypes.LOAD_RECENTLY_PUBLISHED_PROFILES_FAIL: {
      return {
        ...state,
        recentlyPublishedProfiles: action.payload
      };
    }

    case ActionTypes.REQUEST_PROFILES_FOR_APPLICATION:
    case ActionTypes.LOAD_PROFILES_FOR_APPLICATION_SUCCESS:
    case ActionTypes.LOAD_PROFILES_FOR_APPLICATION_FAIL: {
      const { application } = state;
      return {
        ...state,
        application: {
          ...application,
          ...action.payload
        }
      };
    }

    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }

      return {
        ...state,
        featuredProfiles: {
          loading: false,
          loaded: false,
          error: false,
          profiles: []
        },
        recentlyPublishedProfiles: {
          loading: false,
          loaded: false,
          error: false,
          profiles: []
        }
      };
    }
    default: {
      return state;
    }
  }
}

export const actions = {
  /* featured recruitment profiles list */
  loadFeaturedProfiles,
  loadFeaturedProfilesSuccess,
  loadFeaturedProfilesFailure,

  /* recently recruitment profiles list */
  loadRecentlyPublishedProfiles,
  loadRecentlyPublishedProfilesSuccess,
  loadRecentlyPublishedProfilesFailure,

  /* own profiles list */
  updateOwnProfiles,
  loadOwnProfiles,
  loadProfilesSuccess,
  loadProfilesFailure,

  /* application */
  requestProfilesForApplication,
  loadApplicationProfilesSuccess,
  loadApplicationProfilesFail
};
